export const urllogout = (redir = '') => {
    return `https://connectid.no/user/logout?clientId=no.kommunebarometeret&returnUrl=https://${window.location.host}/kommunebarometeret&errorUrl=https://${window.location.host}/kommunebarometeret`;
};
